export default __webpack_public_path__ + "static/media/contact-youtube.ba2d2a25.svg";